import { DeliveryWindowType, OrderType } from 'graphql-api/gql-api-interfaces';

import {
  BusinessState,
  DataState,
  DeliveryPeriodType,
} from '../../../models/config-strip-state.models';
import { getSelectedDeliveryPeriod } from '../../../shared/get-selected-delivery-period';
import { inventoryFilter } from '../../../shared/inventory-filter';
import { getInventoriesFilteredByShopPeriod } from '../../../shared/shared';
import { isTrueDemandInventory } from '../../../shared/true-demand-inventory';

export function getAvailableInventories({
  state,
  data,
  productId,
  deliveryShopId,
  deliveryPeriodType,
  orderType,
  deliveryPeriod,
  deliveryWindow,
}: {
  state: BusinessState;
  data: DataState;
  productId: string;
  deliveryShopId: string;
  deliveryPeriodType: DeliveryPeriodType;
  orderType: OrderType;
  deliveryPeriod?: string;
  deliveryWindow?: DeliveryWindowType;
}) {
  const deliveryPeriodOrSelected =
    deliveryPeriod || getSelectedDeliveryPeriod(state);

  const otherPeriodsUsedInventories: {
    [inventoryItemId: string]: number;
  } = getInventoriesFilteredByShopPeriod(
    { ...state.usedInventories },
    { deliveryShopId, deliveryPeriod },
  );
  // Don'tuse true demand if there is sizerun
  const filterTrueDemandInventories =
    orderType === OrderType.Now && !!data.sizeRuns?.now;
  const inventories = [
    ...(data.sizes[productId]?.inventoryItems ??
      data.prepacks[productId]?.inventoryItems ??
      []),
  ]
    .filter(
      inventoryFilter(
        orderType,
        deliveryPeriodOrSelected,
        deliveryPeriodType,
        deliveryWindow,
        filterTrueDemandInventories,
      ),
    )
    .map((inv) => {
      const quantity =
        (state.skipInventoryCheck
          ? Number.POSITIVE_INFINITY
          : inv.quantity ?? Number.POSITIVE_INFINITY) -
        (otherPeriodsUsedInventories[inv.itemId] ?? 0);
      return { ...inv, quantity };
    });
  inventories.sort((inv1, inv2) => {
    // sort true demand inventory to the end so real inventories are consumed first
    if (isTrueDemandInventory(inv1.inventoryId)) {
      return 1;
    }
    return inv1.availableToDateUtc.localeCompare(inv2.availableToDateUtc);
  });
  return inventories;
}
